/*
 * Purpose: Pricing plan copy — Basic vs Plus feature lists (marketing SSOT)
 * Last modified: 2026-07-01 | Agent
 * Completeness: 95
 */

export type PricingPlanId = 'basic' | 'plus';

export type PricingPlanDefinition = {
  id: PricingPlanId;
  name: string;
  tagline: string;
  highlighted?: boolean;
  features: string[];
};

export const PRICING_PLANS: PricingPlanDefinition[] = [
  {
    id: 'basic',
    name: 'Basic',
    tagline: 'Ship outcome-driven automations without per-task billing.',
    features: [
      'Up to 3 active missions',
      'Compose & flow builder with dry-run',
      'Native connector library (Gmail, webhooks, MCP)',
      'Mission trail & execution logs',
      'Email, OTP & GitHub sign-in',
      'Standard email support',
    ],
  },
  {
    id: 'plus',
    name: 'Plus',
    tagline: 'Full platform — AI planning, knowledge, and scale.',
    highlighted: true,
    features: [
      'Unlimited active missions',
      'Everything in Basic',
      'Map AI assistant & workflow refinement',
      'Mission knowledge RAG & dossier',
      'AI integration discovery',
      'Scheduled flows & live runs dashboard',
      'Admin analytics & priority support',
    ],
  },
];
